import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SwiperCore, {
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
} from "swiper";
import "@styles/react/libs/swiper/swiper.scss";
import { useDispatch, useSelector } from "react-redux";
import { getBanner } from "@store/action/smartend/BannerAction";
import { useEffect } from "react";

SwiperCore.use([
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
]);
const params = {
  spaceBetween: 30,
  centeredSlides: true,
  autoplay: {
    delay: 10000,
    disableOnInteraction: false,
  },
  pagination: false,
  navigation: false,
};
const SwiperAutoplay = () => {
  const BannerReducer = useSelector((state) => state.BannerReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBanner({ per_page: 1000 }));
  }, [dispatch]);

  return (
    <div style={{ position: "sticky" }}>
      {BannerReducer ? (
        <Swiper className="swiperBanner" {...params}>
          {BannerReducer?.BannerSections?.map((item, i) => (
            <div key={i}>
              {item.status === 1 ? (
                <SwiperSlide style={{ width: "100%", height: "100%" }} key={i}>
                  {item.type.name === "Text" ? (
                    <div className="banner_bg_home">
                      <a
                        href={item.link_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="banner-content">
                              <h1>{item.title}</h1>
                              <p>{item.details}</p>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  ) : item.type.name === "Picture" ? (
                    <div className="box effect5">
                      <img
                        src={item.file && item.file}
                        alt="swiper 1"
                        style={{ width: "100%" }}
                        className="banner_bg_img"
                      />
                      <div className="banner_bg_home">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="banner-content">
                              <h1>{item.title}</h1>
                              <p>{item.details}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <video
                      src={item.file}
                      autoPlay
                      muted
                      style={{
                        width: "50%",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    />
                  )}
                </SwiperSlide>
              ) : null}
            </div>
          ))}
        </Swiper>
      ) : null}
    </div>
  );
};

export default SwiperAutoplay;
